module.exports = __webpack_public_path__ + "img/s7-2.dd9d6202.png";